<template>
  <div class="vl-personal-interface">
    <div class="pm-bread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'personDefault' }"
          >个人中心</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ name: 'personDefault' }"
          >我的应用</el-breadcrumb-item
        >
        <el-breadcrumb-item>接口订阅</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="leftTree">
      <div style="padding: 20px 10px 15px">
        <el-input placeholder="输入接口名称" v-model="filterText">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="getInterfaceData('')"
          ></i>
        </el-input>
      </div>
      <el-tree
        class="filter-tree"
        :data="options"
        :props="defaultProps"
        @node-click="filterNode"
        ref="tree"
      >
      </el-tree>
    </div>
    <div class="rightTable">
      <ul class="generalize">
        <!-- 
        <li>
          <div style="display: flex;">
            <img src="../../../../assets/img/personalCenter/required.png" alt="">
            <div class="character">
              <span>必选接口</span> <br>
              <span>{{mustApiNum}}个</span>
            </div>
          </div>
        </li>
         -->
        <li>
          <div style="display: flex">
            <img
              src="../../../../assets/img/personalCenter/subscription.png"
              alt=""
            />
            <div class="character">
              <span>订阅接口</span><br />
              <span>{{ needApiNum }}个</span>
            </div>
          </div>
        </li>
        <li>
          <div style="display: flex">
            <img src="../../../../assets/img/personalCenter/total.png" alt="" />
            <div class="character">
              <span>接口总数</span><br />
              <span>{{ apiNum }}个</span>
            </div>
          </div>
        </li>
        <el-button
          class="submitApplications"
          :disabled="isDis"
          @click="takeInterface"
          >提交申请</el-button
        >
      </ul>
      <el-table :data="gridData" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          prop="apiDesignation"
          label="接口名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="apiName"
          label="API名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="apiDescribe"
          label="接口说明"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import {
  PersonalGetApiGroupList,
  PersonalPostApiUnApplyInfo,
  PersonalPostSubmitApi,
} from "@/views/index/api/personalCenter/api.personalCenter.js";
export default {
  data() {
    return {
      appId: null,
      mustApiNum: 0,
      needApiNum: 0,
      apiNum: 0,
      isLogin: document.cookie ? true : false,
      filterText: "",
      defaultProps: {
        children: "children",
        label: "groupName",
      },
      gridData: [],
      multipleSelection: [],
      options: [],
      automatic: "",
      isDis: false,
    };
  },
  mounted() {
    this.appId = this.$route.query.appId;
    this.getInterfaceData();
    this.getApiGroup();
  },
  methods: {
    // 获取分组list
    getApiGroup() {
      PersonalGetApiGroupList().then((res) => {
        if (res && res.result) {
          this.options = res.result;
        }
      });
    },
    // 获取弹窗表格数据
    getInterfaceData(groupId = "") {
      let params = {
        appId: this.appId,
        groupId: groupId,
        searchKey: this.filterText,
      };
      PersonalPostApiUnApplyInfo(params).then((res) => {
        if (res && res.result) {
          this.gridData = res.result.apiInfo;
          this.mustApiNum = res.result.mustApiNum;
          this.needApiNum = res.result.needApiNum;
          this.apiNum = res.result.apiNum;
        }
      });
    },
    // 订阅接口
    takeInterface() {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请先选择接口");
        return;
      }
      this.isDis = true;
      let params = {
        appId: this.appId,
        apiCode: this.multipleSelection,
      };
      PersonalPostSubmitApi(params).then((res) => {
        if (res) {
          this.$MyMessage(res.message, "success");
          this.getInterfaceData();
          this.isDis = false;
        }
      });
    },
    // tree节点点击查询
    filterNode(obj) {
      this.getInterfaceData(obj.apiGroupId);
    },
    // 表格多选
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.apiCode);
    },
  },
};
</script>
<style lang="scss">
.vl-personal-interface {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  min-height: 857px;
  position: relative;
  padding-top: 50px;
  .pm-bread {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    @include setColor("background-color", "chunk_3");
    display: flex;
    align-items: center;
  }
  .leftTree {
    width: 250px;
    background: #fafcfe;
    border: 1px solid #ebeef5;
  }
  .leftTree .el-tree {
    /* padding-left: 20px; */
    /* background: #FAFCFE; */
  }
  .leftTree .span-ellipsis {
    width: 100%;
    height: 100%;
  }
  .leftTree .span-ellipsis span {
    display: block;
    width: 100%;
    height: 100%;
    font-size: 16px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 50px;
  }
  .leftTree .el-tree-node__content {
    height: 55px !important;
    /* background: #FAFCFE; */
  }
  .leftTree .el-tree-node__content:hover {
    background-color: #ecf5fe;
    box-shadow: inset 0 0 1px #c3daf2;
    color: #4286f5;
  }
  /* .leftTree .is-current .el-tree-node__content {

    } */
  // .leftTree .is-current .el-tree-node__content {
  //   color: #4286f5;
  //   position: relative;
  //   background-color: #ecf5fe !important;
  //   box-shadow: inset 0 0 1px #c3daf2;
  // }
  // .leftTree .is-current .el-tree-node__content::before {
  //   content: "";
  //   display: block;
  //   width: 3px;
  //   height: 100%;
  //   background: #4286f5;
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   bottom: 0;
  // }
  // 选中行高亮显示
  .el-tree-node.is-current {
    .el-tree-node__content {
      position: relative;
      background-color: #ecf5fe !important;
      box-shadow: inset 0 0 1px #c3daf2;
      &::before {
        content: "";
        display: block;
        width: 3px;
        height: 100%;
        background: #4286f5;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
      }
      .el-tree-node__label {
        color: #4286f5;
      }
    }
    .el-tree-node__children .el-tree-node > .el-tree-node__content {
      background-color: transparent !important;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 0;
        height: 0;
        background: #4286f5;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
      }
      .el-tree-node__label {
        color: #606266;
      }
    }
  }
  .leftTree .el-tree-node__children .el-tree-node__content .span-ellipsis span {
    font-size: 14px !important;
  }
  .rightTable {
    width: calc(100% - 250px);
    padding: 20px 40px 20px;
    border: 1px solid #ebeef5;
    border-left: none;
  }
  .generalize {
    margin-bottom: 20px;
  }
  .generalize > li {
    display: inline-block;
    padding: 10px 20px;
    border-radius: 4px;
    margin-right: 20px;
    border: 1px solid #f1f3f5;
  }
  .generalize > li .character {
    float: left;
    line-height: normal;
  }
  .generalize > li img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
  .generalize > li .character > span {
    color: #333;
  }
  .generalize > li .character > span:last-child {
    color: #666;
  }
  .submitApplications {
    border: 1px solid #4286f5 !important;
    color: #4286f5 !important;
    float: right !important;
    margin-top: 15px !important;
    background: #fff !important;
    padding: 10px 20px !important;
  }
}
</style>